<template>
  <div @click="onClick()" class="checkbox">
    <div v-if="checked" class="checked"></div>
  </div>
</template>
<script>
export default {
  data: () => ({
    checked: false
  }),

  methods: {
    onClick () {
      this.checked = !this.checked
      this.$emit('clicked', this.checked)
    }
  }
}
</script>
<style lang="postcss">
  .checkbox {
    width: 16px;
    height: 16px;
    border: 1px solid #979797;
    cursor: pointer;
    position: relative;
  }

  .checked {
    background: #777;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 2px;
    left:2px;
  }
</style>
